module.exports = __webpack_public_path__ + "img/butterfly.373e0efa.jpg";